import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import NewsCard from '../components/NewsCard';
import { newsAPI } from '../utils/api/newsAPI';
import './SearchResults.css';

function SearchResults() {
  const location = useLocation();
  const navigate = useNavigate();
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({ pages: 1, total: 0, currentPage: 1 });

  const query = useMemo(() => new URLSearchParams(location.search).get('q')?.trim() || '', [location.search]);

  useEffect(() => {
    if (!query) {
      setResults([]);
      setLoading(false);
      setError('');
      setPagination({ pages: 1, total: 0, currentPage: 1 });
      return;
    }

    const fetchResults = async () => {
      try {
        setLoading(true);
        setError('');
        const response = await newsAPI.searchNews(query, page, 9);

        if (!response.success) {
          throw new Error(response.message || 'Search failed');
        }

        setResults(response.data || []);
        setPagination(response.pagination || { pages: 1, total: 0, currentPage: 1 });
      } catch (fetchError) {
        setError(fetchError.message || 'Search failed');
        setResults([]);
      } finally {
        setLoading(false);
      }
    };

    fetchResults();
  }, [page, query]);

  useEffect(() => {
    setPage(1);
  }, [query]);

  return (
    <section className="search-results-page">
      <div className="search-results-container">
        <header className="search-results-hero">
          <span className="search-results-kicker">Search newsroom</span>
          <h1 className="search-results-title">{query ? `"${query}" ke liye results` : 'Search results'}</h1>
          <p className="search-results-subtitle">
            {query
              ? `${pagination.total || 0} matching stories found across published news.`
              : 'Top bar se koi keyword type karke news search karein.'}
          </p>
        </header>

        {loading ? (
          <div className="search-results-state loading">Results load ho rahe hain...</div>
        ) : error ? (
          <div className="search-results-state error">{error}</div>
        ) : !query ? (
          <div className="search-results-state empty">Search start karne ke liye keyword enter karein.</div>
        ) : results.length === 0 ? (
          <div className="search-results-state empty">Is keyword ke liye koi published news nahi mili.</div>
        ) : (
          <>
            <div className="search-results-grid">
              {results.map((item) => (
                <NewsCard key={item._id || item.slug} news={item} />
              ))}
            </div>

            {pagination.pages > 1 ? (
              <div className="search-results-pagination">
                <button
                  type="button"
                  className="search-page-btn"
                  onClick={() => setPage((current) => Math.max(current - 1, 1))}
                  disabled={page === 1}
                >
                  Previous
                </button>
                <span className="search-page-info">
                  Page {pagination.currentPage} of {pagination.pages}
                </span>
                <button
                  type="button"
                  className="search-page-btn"
                  onClick={() => setPage((current) => Math.min(current + 1, pagination.pages))}
                  disabled={page === pagination.pages}
                >
                  Next
                </button>
              </div>
            ) : null}
          </>
        )}

        <div className="search-results-actions">
          <button type="button" className="search-home-btn" onClick={() => navigate('/')}>
            Home par wapas jao
          </button>
        </div>
      </div>
    </section>
  );
}

export default SearchResults;